<template>
	<div class="useri_right">
			<div class="useri_right_pad">
				<div class="userirp_d1"><span></span>个人资料</div>
				<el-form ref="form" :model="form" label-width="80px">
					<el-form-item label="用户名">
						<el-input :disabled="true" class="userirp_d1_inp" v-model="form.name1" placeholder="输入用户名"></el-input>
					</el-form-item>
					<el-form-item label="姓名">
						<el-input class="userirp_d1_inp" v-model="form.name2" placeholder="输入姓名"></el-input>
					</el-form-item>
					<el-form-item label="手机号">
						<el-input :disabled="true" class="userirp_d1_inp" v-model="form.phone" placeholder="输入手机号"></el-input>
					</el-form-item>
					<el-form-item label="邮箱">
						<el-input class="userirp_d1_inp" v-model="form.email" placeholder="输入邮箱"></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="success" @click="submitForm()">保存</el-button>
					</el-form-item>
				</el-form>
			</div>

		</div>
</template>

<script>
	export default {
		data() {
			return {
				userInfo:"",
				form: {
					name1: '',
					name2: '',
					phone: '',
					email: ''
				}
			}
		},
		computed: {

		},
		watch: {

		},
		created: function() {
			if (this.$store.state.userId != "") {
				this.getUser()
			}
		},
		mounted: function() {

		},
		methods: {
			getUser() {
				var that = this
				that.$post('GetUserModel', {
						UserId: that.$store.state.userId
					})
					.then(function(res) {
						that.userInfo = res.data.ResultData
						that.form.phone = that.userInfo.Mobile
						that.form.name1 = that.userInfo.RealName
						that.form.name2 = that.userInfo.Nick
						that.form.email = that.userInfo.Email 
					})
			},
			submitForm() {
				var that = this
				if(that.form.name1 + that.form.email == ""){
					that.$message.error("请输入更改内容");
					return
				}
				if(that.form.email != ""){
					if(!(/\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(that.form.email))){
						that.$message.error("邮箱格式不正确");
						return
					}
				}
				that.$post('UpdateUserInfo', {
						UserId: that.$store.state.userId,
						Nick:that.form.name2,
						Email:that.form.email
					})
					.then(function(res) {
						if (res.data.Success == "true") {
							that.$message({
								message: res.data.Msg,
								type: 'success'
							});
							if (this.$store.state.userId != "") {
								that.getUser()
							}
						}else{
							that.$message.error(res.data.Msg+111);
						}
					})
			},
			toPwd() {
				this.$router.push("/setPwd")
			},
			toAddress() {
				this.$router.push("/address")
			},
			toOrderList() {
				this.$router.push("/orderList")
			},
			toFast() {
				this.$router.push("/fast")
			},
			toSetPwd() {
				this.$router.push("/setPwd")
			},
			toUserInfo() {
				this.$router.push("/userInfo")
			},
			toCar() {
				this.$router.push("/car")
			}
		}
	}
</script>

<style lang="scss" scoped src="./mobile.scss" ></style>